module.exports = __webpack_public_path__ + "static/media/pack2.1785dd02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pack2.jpg
// module id = 886
// module chunks = 0